import {UseCopilotAgentDefaultBranchRepositoryServerQuery} from '@github-ui/server-persisted-queries'
import type {UseCopilotAgentDefaultBranchRepositoryServerQueryQuery} from '@github-ui/server-persisted-queries/types/UseCopilotAgentDefaultBranchRepositoryServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type RepositoryNode = Extract<
  UseCopilotAgentDefaultBranchRepositoryServerQueryQuery['node'],
  {readonly __typename: 'Repository'}
>

export function copilotAgentDefaultBranchQueryKey(owner: string, name: string) {
  return ['issue-viewer', 'copilot-agent-default-branch', {owner, name}] as const
}

export async function fetchCopilotAgentDefaultBranchRepository(
  owner: string,
  name: string,
  signal?: AbortSignal,
): Promise<RepositoryNode | null> {
  const query = new URLSearchParams({queryId: UseCopilotAgentDefaultBranchRepositoryServerQuery})
  const response = await reactFetchJSON(
    `/${owner}/${name}/copilot_agent_default_branch_repository.json?${query.toString()}`,
    {signal},
  )

  if (!response.ok) throw new Error(`Copilot agent default branch fetch failed (${response.status})`)

  const json = (await response.json()) as {
    data?: UseCopilotAgentDefaultBranchRepositoryServerQueryQuery
    errors?: unknown[]
  }
  if (json.errors?.length || !json.data) throw new Error('Copilot agent default branch query returned errors')

  const node = json.data.node
  return node?.__typename === 'Repository' ? node : null
}
